import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { CurrentTimeZoneExtractorClass } from '@zaoblako/shared/modules/dates/classes/current-time-zone-extractor.class';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';

import * as yup from 'yup';
import moment from 'moment-timezone';

/** Salary accrual create/update request body */
export interface SalaryAccrualFormInterface {
  /** Counterparty */
  contragent: ContragentFindInterface;
  /** Calculation month */
  period: Date;
  /** Accrual amount */
  amount: number;
}

/** Salary accrual create/update request body - DTO schema */
export const SalaryAccrualFormDto = SerdeDtoClass.create<SalaryAccrualFormInterface>(DocumentDtoKeysEnum.SALARY_ACCRUAL_FORM_DTO, {
  contragent: {
    label: 'Контрагент',
    serializer: entityLikeSchema,
    checkers: [ClientCheckerKeysEnum.CONTRAGENT_ASSERT_EXISTS_BY_DTO],
  },
  period: {
    label: 'Месяц расчёта',
    serializer: yup.date().transform(
      value => moment
        .tz(value, CurrentTimeZoneExtractorClass.getInstance().getCurrentTimeZone())
        .startOf('month')
        .toDate(),
    ),
  },
  amount: {
    label: 'Сумма ЗП',
    serializer: yup.number().min(0, DtoMessageEnum.NOT_ZERO_OR_POSITIVE),
  },
});
